package de.oevbs.kunde.kundenportal2.components

import de.oevbs.kosmos.ui.elements.button.btn
import de.oevbs.kosmos.ui.icons.icon
import de.oevbs.kosmos.ui.layouts.card
import de.oevbs.kunde.kundenportal2.Pages
import de.oevbs.kunde.kundenportal2.navigation.Page
import de.oevbs.kunde.kundenportal2.navigation.visit
import dev.fritz2.core.RenderContext
import dev.fritz2.core.joinClasses
import dev.fritz2.headless.validation.Severity

fun RenderContext.messageCardWithContent(
    message: String,
    content: RenderContext.() -> Unit
) {
    card {
        paragraph { +message }
        content()
    }
}

fun RenderContext.messagePageText(
    header: String,
    text: String,
    buttonLabel: String = "",
    pageTarget: Page? = null,
    severity: Severity = Severity.Success,
    showRedirectNotice: Boolean = true
) {
    messageHeader(header, severity) {

        paragraph {

            +text

            if (showRedirectNotice && (pageTarget != null && buttonLabel.isNotBlank())) {
                br {}
                +"Sollten Sie nicht automatisch weitergeleitet werden, klicken Sie bitte auf den nachstehenden Button."
            }
        }

        if (pageTarget != null && buttonLabel.isNotBlank()) {
            buttonContainer {
                btn {
                    label(buttonLabel)
                }.clicks handledBy { pageTarget.visit() }

                if (severity == Severity.Error) {
                    btn {
                        label("Fehler melden")
                    }.clicks handledBy {
                        Pages.contactErrorForm.visit()
                    }
                }
            }
        }
    }
}

fun RenderContext.messagePagePre(
    header: String,
    preContent: String,
    severity: Severity = Severity.Success
) {
    messageHeader(header, severity) {
        div("whitespace-pre-line") { +preContent }
    }
}

fun RenderContext.messagePageRender(
    header: String,
    severity: Severity = Severity.Success,
    renderContent: RenderContext.() -> Unit
) {
    messageHeader(header, severity) {
        renderContent()
    }
}

private fun RenderContext.messageHeader(header: String, severity: Severity, content: RenderContext.() -> Unit) {
    h1(
        joinClasses(
            "w-full mb-5 flex flex-row vui-labelbig-5",
            SeveritySettings(severity).textColor
        )
    ) {
        icon("w-8 h-8 mr-2", icon = SeveritySettings(severity).icon)
        +header
    }
    content()
}